export const WEBSITE_OVERLAY_LAYERS = {
  modal: 10000,
  imagePreview: 11000,
} as const;
